import React from 'react';
import ModalWrapper from './ModalWrapper'

interface ConfirmOrCancelProps {
    title?: string
    className?: string
    confirmLabel?: string
    cancelLabel?: string
    showModal: boolean
    onClose: () => void
    onConfirm: () => void
    onCancel?: () => void
    children?: JSX.Element | JSX.Element[] | string
}

const MiniModal = ({
    title,
    showModal,
    className,
    confirmLabel="Confirm",
    cancelLabel="Cancel",
    onClose,
    onConfirm,
    onCancel = onClose,
    children
}: ConfirmOrCancelProps) => (
    <ModalWrapper 
        className={`standard-mini-modal${className ? ' ' + className : ''}`}
        isOpen={showModal}
        escClose={false}
        onRequestClose={onClose}
    >
        <div className="standard-mini-modal-wrapper">
            <h3 className="standard-mini-modal-title">{title}</h3>
            <div className="standard-mini-modal-content">
                {children}
            </div>
            <div className="standard-mini-modal-button-wrapper">
                <button className="btn-blue btn confirm-button" onClick={onConfirm}>
                    {confirmLabel}
                </button>
                
             
                <button className="user-upload-btn-clear btn cancel-button" onClick={onCancel}>
                    {cancelLabel}
                </button>
            </div>
        </div>
        
      
        
    </ModalWrapper>
)

export default MiniModal;